import React from 'react'
import styles from './Button.module.scss'

const Button = ({ onClick }) => {
  return (
    <div>
      <div id="container">
        <button className={styles.learn_more} onClick={onClick}>
          <span className={styles.circle} aria-hidden="true">
            <span className={`${styles.icon} ${styles.arrow}`}></span>
          </span>
          <span className={styles.button_text}>Visit Site</span>
        </button>
      </div>

    </div>

  )
}

export default Button